enum Mutation {
  SET_SEARCH = 'setSearch',
}

export default Mutation;
